import axios from "axios"
 const baseURL = 'https://www.api.iv.myeasytransfer.com/V2'

const axiosInstance= axios.create({
    baseURL,
    timeout: 20000,
})


//1
export const listeProviders = async (body: { isActive: boolean, userId:string }, token:string |undefined,) => {

  const { data } = await 
  axiosInstance.post('/activeProviders', body, {
      headers:{
          Authorization: `Bearer ${token}`,

          accept: 'application/json' 
        }
         ,
    })
    return data
  
}

// 2
export const userFacture = (token: any, body: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post('/userInvoices', body, {
        headers: {
          authorization: `Bearer ${token}`,
          accept: 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//3
export const payedFacture = (token: string | undefined ,body: any, paymentMode: string | undefined) =>
 axiosInstance

    .post(`${paymentMode}/payInvoice`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

    // 4
    export const confirmPayment = (invoice_id: string | undefined, payementMode:string | undefined) =>
  axiosInstance
    .post(
      `/${payementMode}/confirmPayment`,
      { invoice_id },
      {
        headers: {
          accept: 'application/json',
        },
      },
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

    // 5
//     export const tracks = (body: any) =>
//   axiosInstance
//     .post(`/tracks/track`, body, {
//       headers: {
//         accept: 'application/json',
//       },
//     })
//     .then((response) => {
//       return response?.data
//     })
//     .catch((error) => {
//       console.log(error)
// })
